var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiDorsoPy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 150,
    viewBox: "0 0 232 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.697 45.1638C197.839 40.8742 195.325 37.0994 191.705 34.6636C188.085 32.2278 183.652 31.3288 179.373 32.1627L164.158 35.1973C167.649 33.3294 170.356 30.2645 171.784 26.561C173.213 22.8575 173.269 18.7619 171.942 15.0205C170.614 11.279 167.993 8.14078 164.554 6.17745C161.115 4.21412 157.089 3.55647 153.207 4.32428L51.7651 25.2222C49.5375 25.5415 47.3983 26.3147 45.4794 27.4946C43.5604 28.6743 41.9021 30.2358 40.6062 32.0827C39.3105 33.9297 38.4047 36.0232 37.9446 38.2346C37.4845 40.4459 37.4797 42.7284 37.9307 44.9417C38.3816 47.1549 39.2787 49.2522 40.5667 51.1046C41.8548 52.9571 43.5066 54.5251 45.4208 55.7132C47.3348 56.9008 49.4707 57.6834 51.697 58.0117C53.9233 58.3405 56.193 58.2086 58.3666 57.6241L64.0112 56.4643C61.2731 58.3493 59.165 61.0199 57.9627 64.1271C56.7604 67.2344 56.5196 70.6333 57.2719 73.8797C58.0241 77.1261 59.7346 80.0694 62.1795 82.3252C64.6245 84.58 67.6901 86.0428 70.976 86.5211L64.0691 87.863C61.8438 88.1655 59.7034 88.9211 57.7791 90.083C55.8547 91.2449 54.1867 92.7887 52.8775 94.6203C51.5682 96.4528 50.645 98.5325 50.1646 100.735C49.6841 102.938 49.6565 105.214 50.0833 107.428C50.5101 109.641 51.3825 111.744 52.647 113.607C53.9114 115.47 55.5413 117.055 57.4369 118.264C59.3325 119.472 61.4539 120.28 63.6712 120.637C65.8885 120.994 68.155 120.892 70.3321 120.339L177.852 99.4438C181.776 98.6176 185.265 96.3847 187.669 93.1625C190.073 89.9403 191.226 85.9503 190.913 81.9368C190.599 77.924 188.841 74.1627 185.967 71.356C183.093 68.5493 179.298 66.8895 175.294 66.6869L185.732 64.6076C190.017 63.7498 193.788 61.221 196.219 57.5761C198.648 53.9312 199.539 49.4675 198.697 45.1638Z",
    fill: "#C7E5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9991 64.0286C36.8746 64.0286 38.395 62.506 38.395 60.6276C38.395 58.7493 36.8746 57.2266 34.9991 57.2266C33.1235 57.2266 31.603 58.7493 31.603 60.6276C31.603 62.506 33.1235 64.0286 34.9991 64.0286Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.473 10.0132C145.01 10.0132 147.068 7.95313 147.068 5.41187C147.068 2.87063 145.01 0.810547 142.473 0.810547C139.935 0.810547 137.878 2.87063 137.878 5.41187C137.878 7.95313 139.935 10.0132 142.473 10.0132Z",
    stroke: "#808080",
    strokeWidth: 1.56,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2133 13.8031C73.3095 13.8031 75.0088 12.0117 75.0088 9.80193C75.0088 7.59217 73.3095 5.80078 71.2133 5.80078C69.1171 5.80078 67.4177 7.59217 67.4177 9.80193C67.4177 12.0117 69.1171 13.8031 71.2133 13.8031Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.146 97.5301C200.58 97.5301 201.742 96.4558 201.742 95.1301C201.742 93.8036 200.58 92.7285 199.146 92.7285C197.711 92.7285 196.548 93.8036 196.548 95.1301C196.548 96.4558 197.711 97.5301 199.146 97.5301Z",
    stroke: "#808080",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.542 131.014C79.9761 131.014 81.1389 129.939 81.1389 128.614C81.1389 127.287 79.9761 126.213 78.542 126.213C77.1077 126.213 75.9451 127.287 75.9451 128.614C75.9451 129.939 77.1077 131.014 78.542 131.014Z",
    stroke: "#808080",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68 90.038C156.539 90.038 172.638 73.9162 172.638 54.028C172.638 34.1399 156.539 18.0176 136.68 18.0176C116.821 18.0176 100.722 34.1399 100.722 54.028C100.722 73.9162 116.821 90.038 136.68 90.038Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2798 102.873V72.7292L54.5368 71.4297C51.1521 72.8158 43.2435 77.9781 38.6865 87.5412C34.1295 97.1039 47.85 101.747 55.2798 102.873Z",
    fill: "#BA5C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.319 33.5391H57.4233C54.0896 33.5391 51.3872 36.3396 51.3872 39.7944V87.2834C51.3872 90.7383 54.0896 93.5388 57.4233 93.5388H166.319C169.653 93.5388 172.355 90.7383 172.355 87.2834V39.7944C172.355 36.3396 169.653 33.5391 166.319 33.5391Z",
    fill: "#515151",
    stroke: "#545454",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.485 35.1602H60.2247C58.9069 35.1602 57.8386 36.3258 57.8386 37.7637V89.3132C57.8386 90.7515 58.9069 91.9167 60.2247 91.9167H159.485C160.802 91.9167 161.871 90.7515 161.871 89.3132V37.7637C161.871 36.3258 160.802 35.1602 159.485 35.1602Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2797 60.0897C55.2797 59.8051 55.0492 59.5742 54.7649 59.5742C54.4806 59.5742 54.2502 59.8051 54.2502 60.0897V66.7908C54.2502 67.0754 54.4806 67.3062 54.7649 67.3062C55.0492 67.3062 55.2797 67.0754 55.2797 66.7908V60.0897Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4124 94.1095C77.6967 94.1095 77.9271 93.8784 77.9271 93.5938C77.9271 93.3092 77.6967 93.0781 77.4124 93.0781H69.177C68.8928 93.0781 68.6624 93.3092 68.6624 93.5938C68.6624 93.8784 68.8928 94.1095 69.177 94.1095H77.4124Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.192 94.1095C87.4763 94.1095 87.7067 93.8784 87.7067 93.5938C87.7067 93.3092 87.4763 93.0781 87.192 93.0781H78.9566C78.6723 93.0781 78.4419 93.3092 78.4419 93.5938C78.4419 93.8784 78.6723 94.1095 78.9566 94.1095H87.192Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0007 33.8004C98.285 33.8004 98.5155 33.5696 98.5155 33.285C98.5155 33.0003 98.285 32.7695 98.0007 32.7695H82.5594C82.2751 32.7695 82.0447 33.0003 82.0447 33.285C82.0447 33.5696 82.2751 33.8004 82.5594 33.8004H98.0007Z",
    fill: "#000014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.387 41.3516H68.3226C67.4318 41.3516 66.7097 42.0776 66.7097 42.9732V85.1353C66.7097 86.0313 67.4318 86.757 68.3226 86.757H151.387C152.278 86.757 153 86.0313 153 85.1353V42.9732C153 42.0776 152.278 41.3516 151.387 41.3516Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0572 63.6973V74.724C49.3645 76.1179 45.4901 80.237 43.5342 85.5599C41.0892 92.2142 42.8844 96.7775 45.7056 96.2066C48.5267 95.6366 50.493 93.925 53.8783 90.1231C56.5866 87.081 58.8043 81.9485 60.323 75.8643C60.1349 73.7731 62.0862 67.4277 65.0689 65.7885C68.4049 63.955 70.2064 65.5014 70.429 65.7885C71.1032 66.6581 70.8052 69.4009 69.4886 74.724C68.1721 80.0473 66.4794 89.3626 66.4794 101.72C66.4794 111.606 60.9323 119.59 58.4246 122.633L63.4702 141.263C63.2821 142.087 60.5362 143.849 51.0572 144.306C41.5781 144.762 36.1992 142.467 34.6946 141.263C34.1931 137.271 34.6947 126.054 31.1211 111.606C26.8475 94.3264 27.687 90.3129 29.3796 85.5599C30.7338 81.758 45.6657 68.1334 51.0572 63.6973Z",
    fill: "#E9766C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.499 73.3647C69.7942 73.0606 70.4827 69.0585 70.7901 67.0956C70.4212 66.7152 69.3884 66.1833 68.208 67.0956C66.7324 68.2353 66.3635 72.0349 66.3635 72.6049C66.3635 73.1745 69.1301 73.7446 69.499 73.3647Z",
    fill: "#FCA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4488 91.5332C51.162 92.8216 45.6275 97.0775 43.7388 100.086",
    stroke: "#AB5450",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1398 122.124C59.6565 121.518 63.2588 115.495 64.3964 112.089C61.5524 110.763 59.2774 117.014 57.0022 119.663C55.1821 121.783 51.4408 123.071 49.7976 123.449C49.3426 125.114 49.9873 137.771 50.3665 143.891C56.2818 144.194 61.5525 142.251 63.4485 141.24L58.1398 122.124Z",
    fill: "#DB6C62"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M136.858 81.2047L139.31 78.7402",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M133.901 81.1779L139.476 76.1621",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M131.26 81.1788L139.476 73.8027",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M127.152 81.1787L139.476 68.1973",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M129.499 81.1777L139.476 71.1465",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M124.804 81.1771L139.476 66.4258",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M121.576 81.1782L139.476 63.1816",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M118.826 81.2028L139.309 60.6094",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M112.658 81.2036L139.31 54.4082",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M109.251 81.1787L139.476 50.791",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M105.731 81.1778L139.476 47.25",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M115.707 81.1785L139.476 57.2812",
    stroke: "#0097AF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.053 86.7285C183.446 88.1223 186.381 92.165 186.989 97.1847",
    stroke: "#E3A4A1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_899_5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.151 43.6816H75.8492C74.2423 43.6816 72.9397 44.9843 72.9397 46.5911V82.1515C72.9397 83.7583 74.2423 85.061 75.8492 85.061H141.151C142.758 85.061 144.06 83.7583 144.06 82.1515V46.5911C144.06 44.9843 142.758 43.6816 141.151 43.6816Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.504 44.9746H76.4958C75.4246 44.9746 74.5562 45.843 74.5562 46.9143V81.8281C74.5562 82.8993 75.4246 83.7677 76.4958 83.7677H140.504C141.576 83.7677 142.444 82.8993 142.444 81.8281V46.9143C142.444 45.843 141.576 44.9746 140.504 44.9746Z",
    fill: "#E7F0F6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M77.4402 44.9473L74.7393 47.6482",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M80.6982 44.9766L74.5559 50.4723",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M83.6076 44.9766L74.5559 53.0585",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M88.1335 44.9766L74.5559 59.2007",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M85.5473 44.9766L74.5559 55.9679",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M90.7197 44.9766L74.5559 61.1404",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M94.2757 44.9766L74.5559 64.6964",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M97.3055 44.9473L74.7393 67.5135",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M104.101 44.9473L74.7393 74.3094",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M107.853 44.9766L74.5559 78.274",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M111.733 44.9766L74.5559 82.1533",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M100.741 44.9766L74.5559 71.1619",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M139.56 83.7969L142.261 81.0959",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M136.302 83.7676L142.444 78.2719",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M133.392 83.7676L142.444 75.6857",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M128.867 83.7676L142.444 69.5434",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M131.453 83.7676L142.444 72.7762",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M126.28 83.7676L142.444 67.6038",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M122.724 83.7676L142.444 64.0477",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M119.694 83.7969L142.261 61.2306",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M112.899 83.7969L142.261 54.4347",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M109.147 83.7676L142.444 50.4702",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M105.267 83.7676L142.444 46.5909",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M116.259 83.7676L142.444 57.5822",
    stroke: "#0097AF",
    strokeWidth: 0.420259,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M92.013 46.9141H81.0216C80.3075 46.9141 79.7285 47.493 79.7285 48.2072V60.1684C79.7285 60.8825 80.3075 61.4615 81.0216 61.4615H92.013C92.7272 61.4615 93.3061 60.8825 93.3061 60.1684V48.2072C93.3061 47.493 92.7272 46.9141 92.013 46.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M80.6294 60.7302H92.3055C92.1867 60.411 91.9782 60.1329 91.7051 59.9294C91.2732 59.6257 90.8012 59.3832 90.3028 59.2089C89.8363 59.0214 89.3672 58.839 88.9098 58.6302C88.7035 58.539 88.5194 58.4043 88.3701 58.2354C88.2207 58.0664 88.1096 57.8672 88.0444 57.6513C87.9739 57.4458 87.9449 57.2283 87.9589 57.0115C87.9729 56.7946 88.0298 56.5827 88.1262 56.388C88.4317 55.7977 88.7843 55.23 89.0533 54.6232C89.4145 53.8847 89.5811 53.0662 89.5372 52.2453C89.4933 51.4243 89.2404 50.6282 88.8025 49.9325C88.5769 49.5721 88.2677 49.2714 87.9012 49.0561C87.5346 48.8407 87.1215 48.7169 86.697 48.6953C86.0992 48.6145 85.4914 48.7278 84.9629 49.0186C84.3746 49.3859 83.9384 49.953 83.7345 50.6159C83.3242 51.776 83.3071 53.0389 83.686 54.2097C83.8332 54.8537 84.0969 55.4654 84.4641 56.0146C84.5904 56.19 84.6906 56.3829 84.7615 56.5871C84.8365 56.7816 84.8736 56.9887 84.8708 57.1971C84.8597 57.5566 84.7329 57.9029 84.5092 58.1845C84.2854 58.4661 83.9768 58.6679 83.6291 58.7598C82.7735 58.9895 81.9703 59.3825 81.264 59.9172C80.9945 60.1376 80.7777 60.4153 80.6294 60.7302Z",
    fill: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.4483 74.0703H78.4354C77.8998 74.0703 77.4656 74.5045 77.4656 75.0401C77.4656 75.5758 77.8998 76.01 78.4354 76.01H99.4483C99.984 76.01 100.418 75.5758 100.418 75.0401C100.418 74.5045 99.984 74.0703 99.4483 74.0703Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.297 76.9785H78.4354C77.8998 76.9785 77.4656 77.4127 77.4656 77.9483C77.4656 78.484 77.8998 78.9182 78.4354 78.9182H104.297C104.833 78.9182 105.267 78.484 105.267 77.9483C105.267 77.4127 104.833 76.9785 104.297 76.9785Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4268 79.8887H78.4354C77.8998 79.8887 77.4656 80.3229 77.4656 80.8585C77.4656 81.3941 77.8998 81.8283 78.4354 81.8283H89.4268C89.9624 81.8283 90.3966 81.3941 90.3966 80.8585C90.3966 80.3229 89.9624 79.8887 89.4268 79.8887Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.651 74.0703H102.035C101.499 74.0703 101.065 74.5045 101.065 75.0401C101.065 75.5758 101.499 76.01 102.035 76.01H103.651C104.187 76.01 104.621 75.5758 104.621 75.0401C104.621 74.5045 104.187 74.0703 103.651 74.0703Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.888 79.8887H102.681C102.145 79.8887 101.711 80.3229 101.711 80.8585C101.711 81.3941 102.145 81.8283 102.681 81.8283H138.888C139.424 81.8283 139.858 81.3941 139.858 80.8585C139.858 80.3229 139.424 79.8887 138.888 79.8887Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.086 74.0703H106.237C105.702 74.0703 105.267 74.5045 105.267 75.0401C105.267 75.5758 105.702 76.01 106.237 76.01H111.086C111.622 76.01 112.056 75.5758 112.056 75.0401C112.056 74.5045 111.622 74.0703 111.086 74.0703Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.319 76.9785H106.884C106.348 76.9785 105.914 77.4127 105.914 77.9483C105.914 78.484 106.348 78.9182 106.884 78.9182H114.319C114.855 78.9182 115.289 78.484 115.289 77.9483C115.289 77.4127 114.855 76.9785 114.319 76.9785Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1854 79.8887H92.3363C91.8007 79.8887 91.3665 80.3229 91.3665 80.8585C91.3665 81.3941 91.8007 81.8283 92.3363 81.8283H97.1854C97.721 81.8283 98.1552 81.3941 98.1552 80.8585C98.1552 80.3229 97.721 79.8887 97.1854 79.8887Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.642 75.0401C114.642 74.5045 114.208 74.0703 113.672 74.0703C113.137 74.0703 112.703 74.5045 112.703 75.0401C112.703 75.5758 113.137 76.01 113.672 76.01C114.208 76.01 114.642 75.5758 114.642 75.0401Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.888 76.9785H117.228C116.693 76.9785 116.259 77.4127 116.259 77.9483C116.259 78.484 116.693 78.9182 117.228 78.9182H138.888C139.423 78.9182 139.858 78.484 139.858 77.9483C139.858 77.4127 139.423 76.9785 138.888 76.9785Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.741 80.8585C100.741 80.3229 100.307 79.8887 99.7716 79.8887C99.236 79.8887 98.8018 80.3229 98.8018 80.8585C98.8018 81.3941 99.236 81.8283 99.7716 81.8283C100.307 81.8283 100.741 81.3941 100.741 80.8585Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.888 74.0703H116.259C115.723 74.0703 115.289 74.5045 115.289 75.0401C115.289 75.5758 115.723 76.01 116.259 76.01H138.888C139.424 76.01 139.858 75.5758 139.858 75.0401C139.858 74.5045 139.424 74.0703 138.888 74.0703Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.115 70.6536C132.312 70.3694 131.582 69.908 130.981 69.3036C130.38 68.6992 129.923 67.9673 129.643 67.1622C129.46 66.6905 129.409 66.178 129.494 65.6793C129.558 65.3983 129.687 65.136 129.869 64.9126C130.051 64.6892 130.282 64.5107 130.544 64.3911C130.808 64.2599 131.111 64.2321 131.393 64.3132C131.96 64.5071 132.153 65.2044 132.212 65.8002C132.34 67.1255 132.219 68.4632 131.856 69.7442C131.883 69.6347 131.877 69.5197 131.838 69.4137C131.8 69.3076 131.731 69.2152 131.641 69.1481C131.457 69.017 131.247 68.9286 131.025 68.8894C130.23 68.6981 128.77 68.0854 128.161 68.6308C127.01 70.2566 130.671 68.4314 131.589 68.8329C131.829 68.9379 132.046 69.0915 132.288 69.1911C132.407 69.2486 132.536 69.2791 132.667 69.2803C132.799 69.2816 132.928 69.2535 133.048 69.1982C133.172 69.1178 133.277 69.0111 133.356 68.8856C133.573 68.5768 133.741 68.2364 133.853 67.8763L133.846 68.3289C133.842 68.3521 133.844 68.3757 133.85 68.3984C133.855 68.4211 133.866 68.4425 133.88 68.4611C133.926 68.5057 134.002 68.4873 134.06 68.4611C134.344 68.3416 134.588 68.1438 134.764 67.8908C134.713 67.9776 134.693 68.0796 134.71 68.179C134.726 68.2785 134.777 68.3689 134.854 68.4346C135.012 68.5621 135.209 68.6307 135.412 68.6286C135.659 68.6509 135.908 68.6046 136.131 68.4946C136.353 68.3846 136.541 68.2152 136.673 68.0053C136.731 67.8977 136.765 67.7789 136.773 67.6571C136.78 67.5353 136.762 67.4131 136.718 67.299C136.675 67.1849 136.608 67.0815 136.521 66.9958C136.434 66.91 136.329 66.844 136.215 66.802C136.093 67.0349 136.032 67.2947 136.038 67.5573C136.044 67.8199 136.116 68.0769 136.247 68.3043C136.387 68.5266 136.597 68.6953 136.845 68.7832C137.092 68.8712 137.362 68.8733 137.611 68.7892L135.509 69.4325C135.377 69.4861 135.233 69.5032 135.092 69.482C134.822 69.4154 134.704 69.106 134.629 68.839L133.713 65.6108",
    stroke: "#DCE4EA",
    strokeWidth: 0.484914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.674 70.293H137.918",
    stroke: "#DCE4EA",
    strokeWidth: 0.484914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.007 61.4629H78.2738C77.8274 61.4629 77.4656 61.8247 77.4656 62.2711C77.4656 62.7174 77.8274 63.0793 78.2738 63.0793H119.007C119.453 63.0793 119.815 62.7174 119.815 62.2711C119.815 61.8247 119.453 61.4629 119.007 61.4629Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.722 64.0488H78.2738C77.8274 64.0488 77.4656 64.4107 77.4656 64.857C77.4656 65.3034 77.8274 65.6652 78.2738 65.6652H106.722C107.168 65.6652 107.53 65.3034 107.53 64.857C107.53 64.4107 107.168 64.0488 106.722 64.0488Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.571 66.6348H78.2738C77.8274 66.6348 77.4656 66.9966 77.4656 67.443C77.4656 67.8893 77.8274 68.2511 78.2738 68.2511H111.571C112.018 68.2511 112.379 67.8893 112.379 67.443C112.379 66.9966 112.018 66.6348 111.571 66.6348Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.61 69.2207H78.2738C77.8274 69.2207 77.4656 69.5825 77.4656 70.0289C77.4656 70.4752 77.8274 70.8371 78.2738 70.8371H99.61C100.056 70.8371 100.418 70.4752 100.418 70.0289C100.418 69.5825 100.056 69.2207 99.61 69.2207Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9009 47.5625H78.1121V58.8772H84.9009V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.746 47.5625H125.634V58.8772H132.746V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.724 47.5625H118.845V51.4418H122.724V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.875 47.5625H115.935V49.5022H117.875V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.996 47.5625H111.733V53.3815H113.996V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.853 47.5625H105.914V49.5022H107.853V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.914 49.502H103.974V55.6442H105.914V49.502Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.724 51.7656H120.784V54.0286H122.724V51.7656Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.724 54.0273H120.784V56.9368H122.724V54.0273Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.724 56.9375H120.784V58.8772H122.724V56.9375Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.784 54.0273H117.875V56.9368H120.784V54.0273Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.784 52.4121H117.875V54.675H120.784V52.4121Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.875 56.9375H115.935V58.8772H117.875V56.9375Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.065 56.9375H98.8018V58.8772H101.065V56.9375Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.004 54.0273H98.8018V56.9368H103.004V54.0273Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8017 55.9668H96.8621V57.9065H98.8017V55.9668Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.862 53.0586H94.9224V58.8776H96.862V53.0586Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.862 50.4727H94.9224V52.4123H96.862V50.4727Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.065 47.5625H96.8621V51.4418H101.065V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8017 51.7656H96.8621V54.0286H98.8017V51.7656Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.004 49.8262H101.065V55.9684H103.004V49.8262Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.996 56.9375H111.733V58.8772H113.996V56.9375Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.703 55.9668H110.763V57.9065H112.703V55.9668Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.763 54.0273H107.854V56.9368H110.763V54.0273Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.853 53.3809H105.914V54.3507H107.853V53.3809Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.974 47.5625H102.034V49.5022H103.974V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.944 47.8867H103.004V57.9083H104.944V47.8867Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.763 55.9668H103.974V58.8763H110.763V55.9668Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.966 54.0273H112.703V56.9368H114.966V54.0273Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.935 50.1484H112.703V54.351H115.935V50.1484Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.703 49.502H110.763V53.3813H112.703V49.502Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.763 50.7949H107.854V54.0277H110.763V50.7949Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.815 51.7656H115.935V56.938H119.815V51.7656Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.815 49.502H117.875V53.3813H119.815V49.502Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1033 47.5625H86.1938V58.8772H89.1033V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.625 47.5625H133.716V58.8772H136.625V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9829 47.5625H91.0432V58.8772H92.9829V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.535 47.5625H138.565V58.8772H139.535V47.5625Z",
    fill: "#DCE4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48 109.541C141.239 111.213 139.151 112.772 138.011 113.342C136.556 111.251 133.645 106.841 133.645 105.928C133.645 104.788 134.784 104.217 135.923 104.217C137.062 104.217 139.53 107.449 140.48 109.541Z",
    fill: "#FCA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.615 76.6504C160.539 80.5158 168.955 90.0348 171.232 97.1821",
    stroke: "#E3A4A1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.612 82.3535C174.46 84.1908 180.193 89.6541 180.345 96.8022",
    stroke: "#E3A4A1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.551 126.081L158.134 122.279C162.689 114.522 154.337 94.7125 149.591 85.7773C156.615 92.8111 160.412 103.078 163.26 111.443C165.538 118.134 163.069 123.99 161.551 126.081Z",
    fill: "#BA5C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.764 123.73C200.627 134.261 201.411 138.956 202.419 142.079C202.853 143.419 202.091 144.967 200.706 145.211L176.963 149.394C175.077 146.154 168.34 143.36 160.23 141.264C152.119 139.167 147.593 130.4 145.707 126.207C143.82 122.013 134.956 108.291 134.201 106.767C133.447 105.242 133.069 103.717 136.276 103.717C139.482 103.717 142.689 105.813 147.593 112.104C152.497 118.392 157.589 122.395 158.155 122.395C158.721 122.395 160.607 113.628 157.589 104.67C154.571 95.7122 149.102 84.086 147.593 82.3712C146.084 80.6565 137.031 66.3616 136.842 62.7405C136.653 59.1193 139.105 58.9286 141.369 59.5003C143.179 59.958 152.182 71.1265 156.458 76.6533C163.851 77.2637 169.974 80.7199 172.112 82.3712C177.092 82.0671 180.726 85.0403 181.92 86.5647C186.296 86.7171 190.031 93.8701 191.351 97.4279C194.935 106.768 193.048 106.386 197.764 123.73Z",
    fill: "#E9766C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.202 59.7307C139.568 58.6662 141.302 59.4142 141.998 59.9209L145.985 64.6739L145.605 64.8637C144.542 65.7766 141.998 66.258 140.859 66.3848C139.404 64.6105 136.835 60.7956 138.202 59.7307Z",
    fill: "#FCA2AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_899_5950",
    x: 71.6466,
    y: 43.0351,
    width: 73.7068,
    height: 43.9651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.646552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.646552
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_899_5950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_899_5950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_5950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 150,
    fill: "white",
    transform: "translate(28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiDorsoPy);
export default __webpack_public_path__ + "static/media/CIDorso_py.5d37cb6ba77c79bc5f369332a948fafc.svg";
export { ForwardRef as ReactComponent };